type Emphasis = 'critical' | 'warning' | 'info';

export const STATUS_CODES_MAP: Record<number, { emphasis: Emphasis; message: string }> = {
  1: { emphasis: 'info', message: 'PLEASE_SIGN_IN_NEW' },
  2: { emphasis: 'info', message: 'SESSION_EXPIRED_NEW' },
  3: { emphasis: 'info', message: 'PLEASE_AUTH_FACTOR' },
  4: { emphasis: 'critical', message: 'ACCOUNT_SUSPENDED' },
  5: { emphasis: 'info', message: 'PLEASE_RELOGIN_TO_CONTINUE_NEW' },
  6: { emphasis: 'info', message: 'PLEASE_COMPLETE_2F_AGAIN_TO_CONTINUE' },
  7: { emphasis: 'info', message: 'PLEASE_COMPLETE_2F_TO_CONTINUE' },
  9: { emphasis: 'warning', message: 'REMEMBER_ME_INFO' },
  10: { emphasis: 'critical', message: 'YOUR_ACCOUNT_IS_NOT_AUTHORIZED' },
  11: { emphasis: 'critical', message: 'FB_USER_EMAIL_PERMISSION' },
  12: { emphasis: 'critical', message: 'FB_USER_CONFIRMED_EMAIL_REQ' },
  13: { emphasis: 'critical', message: 'FACEBOOK_UNVERIFIED_ACCOUNT' },
  14: { emphasis: 'critical', message: 'SOCIAL_LOGIN_DISABLED' },
  15: { emphasis: 'critical', message: 'WRONG_SOCIAL_ACCOUNT' },
  16: { emphasis: 'critical', message: 'FACEBOOK_EMAIL_ALREADY_LINKED_TO_SHOPPER' },
  17: { emphasis: 'critical', message: 'SOCIAL_ACCOUNT_ALREADY_LINKED_TO_SHOPPER' },
  18: { emphasis: 'critical', message: 'SOCIAL_TROUBLE_SIGNING_IN' },
  19: { emphasis: 'critical', message: 'ACCOUNT_LOCKED' },
  20: { emphasis: 'critical', message: 'ERROR_MSG_DEFAULT' },
  21: { emphasis: 'critical', message: 'ERROR_404' },
  22: { emphasis: 'critical', message: 'TOO_MANY_FACTOR_ATTEMPTS' },
  23: { emphasis: 'critical', message: 'ERROR_WRONG_DOMAIN' },
  24: { emphasis: 'critical', message: 'ERROR_NOT_SIGNED_IN' },
  25: { emphasis: 'critical', message: 'TROUBLE_SIGNING_IN' },
  26: { emphasis: 'critical', message: 'ACCOUNT_DOESNT_EXIST' },
  27: { emphasis: 'critical', message: 'NOT_ENOUGH_PERMISSION' },
  // 28 we found your account (facebook) modal
  29: { emphasis: 'critical', message: 'ACCOUNT_ALREADY_LINKED_TO_WECHAT' },
  30: { emphasis: 'critical', message: 'INSUFFICIENT_PERMISSIONS_FOR_AFTERNIC' },
  31: { emphasis: 'info', message: 'CRM_MAGIC_LINK_EXPIRED' },
  32: { emphasis: 'info', message: 'MULTI_USERS_ACCEPT_INVITE_SIGN_IN' },
  33: { emphasis: 'info', message: 'INVALID_LOGIN_USE_STUDIO_APP' },
  34: { emphasis: 'warning', message: 'MULTIPLE_ACCOUNTS_LOGIN_WARNING' },
  35: { emphasis: 'info', message: 'MULTI_USERS_INVITE_ALREADY_ACCEPTED' },
};
